import { useEffect, useState } from "react";
import api from "../lib/api";

const TABS = [
  { v: "photo", l: "Photos" },
  { v: "video", l: "Vidéos" },
  { v: "conference", l: "Conférences" },
  { v: "replay", l: "Replays" },
  { v: "interview", l: "Interviews" },
  { v: "archive", l: "Archives" },
];

export default function MediaPage() {
  const [type, setType] = useState("photo");
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/media?type=${type}`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [type]);

  return (
    <div data-testid="media-page">
      <section className="bg-ink text-white py-20 grain relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="eyebrow eyebrow-on-dark"><span className="w-8 h-px bg-gold inline-block align-middle mr-3" />Médias</div>
          <h1 className="font-serif text-5xl lg:text-6xl mt-6 leading-tight tracking-tight">
            Galerie <span className="text-gold italic font-light">institutionnelle.</span>
          </h1>
          <p className="mt-6 text-white/75 max-w-2xl text-lg">Photos, vidéos, conférences, replays et archives.</p>
        </div>
      </section>

      <section className="py-12 bg-bone border-b border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-wrap gap-2">
          {TABS.map((t) => (
            <button key={t.v} onClick={() => setType(t.v)}
                    className={`px-5 py-2.5 text-sm font-semibold rounded-sm transition-colors ${
                      type === t.v ? "bg-ink text-white" : "bg-white border border-border text-foreground/70 hover:border-ink"
                    }`}
                    data-testid={`media-tab-${t.v}`}>
              {t.l}
            </button>
          ))}
        </div>
      </section>

      <section className="py-16 bg-bone">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {items.length === 0 ? <div className="text-foreground/60">Aucun média dans cette catégorie.</div> : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {items.map((m) => (
                <div key={m.id} className="group relative aspect-[4/3] overflow-hidden rounded-sm bg-ink/5 cursor-pointer" data-testid={`media-item-${m.id}`}>
                  {m.type === "video" || m.type === "replay" ? (
                    <iframe src={m.url} title={m.title} className="w-full h-full" allow="autoplay; encrypted-media" allowFullScreen />
                  ) : (
                    <img src={m.url} alt={m.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  )}
                  <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-ink/95 to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="font-serif text-lg leading-tight">{m.title}</div>
                    {m.description && <div className="text-xs text-white/75 mt-1">{m.description}</div>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
